import {
  Configuration,
  RedirectRequest,
  PublicClientApplication,
} from "@azure/msal-browser";
import env from "@config/env";

const msalConfig: Configuration = {
  auth: {
    clientId: env.MSAL_CLIENT_ID,
    authority: env.MSAL_AUTHORITY,
    redirectUri: env.MSAL_REDIRECT_URI,
    postLogoutRedirectUri: env.MSAL_LOGOUT_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: env.MSAL_STORAGE,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: [env.MSAL_PRODUCT_SCOPE, env.MSAL_REFRESH_TOKEN].filter(
    (scope) => scope && scope !== "undefined"
  ),
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const signOutUser = () => {
  const logoutRequest = {
    postLogoutRedirectUri: env.MSAL_LOGOUT_REDIRECT_URI,
    account: msalInstance.getActiveAccount(),
  };
  msalInstance.logoutRedirect(logoutRequest);
};

let tokenPromise: Promise<string> | null = null;

const acquire = async (): Promise<string> => {
  const accounts = msalInstance.getAllAccounts();
  if (!accounts.length) return "";
  try {
    const silent = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });
    return silent.accessToken;
  } catch {
    try {
      const popup = await msalInstance.acquireTokenPopup(loginRequest);
      return popup.accessToken;
    } catch {
      return "";
    }
  }
};

export const getAccessToken = async (force = false): Promise<string> => {
  if (force) {
    tokenPromise = null;
  }
  tokenPromise ??= acquire()
    .then((t) => {
      if (!t) {
        tokenPromise = null;
      }
      return t;
    })
    .catch((err) => {
      console.warn("Token acquisition error:", err);
      tokenPromise = null;
      return "";
    });
  return tokenPromise;
};

export const getUserName = (): string => {
  try {
    const accounts = msalInstance.getAllAccounts();
    if (!accounts.length) return "";
    const { name, username } = accounts[0];
    return name ?? username ?? "";
  } catch {
    return "";
  }
};
